import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { getSettingsData } from '../../Settings/reducer';

export default function ZonePresetModal(props) {
  const { handleClose = () => {}, handleSave = () => {}, selectedPresets = [] } = props;
  const [temp, setTemp] = useState(selectedPresets);
  const intl = useIntl();
  const { formatMessage } = intl;

  const save = () => {
    handleSave(temp);
    handleClose();
  };
  const onChangePreset = id => e => {
    const newValue = [...temp];
    const index = newValue.indexOf(id);
    if (index > -1) {
      newValue.splice(index, 1);
    } else {
      newValue.push(id);
    }
    setTemp(newValue);
  };
  const { presetsList } = useSelector(getSettingsData);
  return (
    <Dialog
      className={classNames('select-presets-dialog-container')}
      onClose={handleClose}
      open
    >
      <DialogTitle header={formatMessage({ id: 'presets.violation' })} title={<Icons onClick={handleClose} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content">
        <div className="preset-select-dialog">
          {(presetsList || []).map((preset, key) => (
            <div key={key} className="preset-select-block">
              <div className="preset-select-checkbox">
                <CheckBoxInputWithLabel
                  inputProps={{
                    onChange: onChangePreset(preset.id),
                    value: temp.includes(preset.id),
                    name: `preset-${key}`,
                  }}
                  withLabel={false}
                  variant="material"
                />
              </div>
              <div className="preset-select-name">
                <TooltipWithPortal classNamePortal="portal-name-tooltip" classNameDropdown="name-tooltip" content={preset.name} />
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogFooter>
        <Button onClick={save}>{formatMessage({ id: 'app.save' })}</Button>
        <Button variant="secondary" onClick={() => handleClose()}>{formatMessage({ id: 'app.close' })}</Button>
      </DialogFooter>
    </Dialog>
  );
}
